module.exports = __webpack_public_path__ + "media/images/png/family-06799bab4b10f8e63f7947ae3049d398.png";